import angular from 'angular';

/**
 * @memberOf cms.input.slug
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.label      Input label string
 * @property {string}   bindings.helper     Form helper object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.disabled   ACL config - disable input
 * @property {function} bindings.aclShow    ACL config - show input
 */
let cmsInputVideo = {
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        model: '=',
        disabled: '<',
        aclShow: '<?',
    },
    template: require('./video.html'),
    controller: function (gettext, $scope) {

        /** @ngInclude */

        this.$onInit = () => {
            this.validate();
        };

        $scope.$on('creator-workspace-selection-changed', () => {
            this.validate();
        });

        this.onBlur = function () {
            this.validate();
            this.parseLink();
        };

        this.onChange = () => {

            this.validate();
            this.parseLink();
        };

        this.parseLink = () => {
            if (this.isValidYoutubeLink()) {
                this.model.video.videoId = this.parseYoutubeId(this.model.video.url);
                this.model.video.videoType = 'youtube';
                this.model.video.data = 'https://www.youtube.com/embed/' + this.model.video.videoId;
            } else if (this.isValidVimeoLink()) {
                this.model.video.videoId = this.parseVimeoId(this.model.video.url);
                this.model.video.videoType = 'vimeo';
                this.model.video.data = 'https://player.vimeo.com/video/' + this.model.video.videoId;
            }
        };

        this.parseYoutubeId = (youtubeLink) => {
            if (youtubeLink.indexOf('v=') !== -1) {
                let linkChunks = youtubeLink.split('v=');
                return linkChunks[1];
            }

            let linkChunks = youtubeLink.split('/');
            return linkChunks[linkChunks.length - 1];
        };

        this.parseVimeoId = (vimeoLink) => {

            let linkChunks = vimeoLink.split('/');

            return linkChunks[linkChunks.length - 1];
        };

        this.validate = () => {
            this.errors = [];
            if (this.isValidVimeoLink() || this.isValidYoutubeLink()) {
                this.errors = [];
            } else {
                this.errors = [gettext('Incorrect url address youtube/vimeo!')];
            }
        };

        this.isValidYoutubeLink = () => {
            let youtubeRegexp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

            return youtubeRegexp.test(this.model.video.url);
        };

        this.isValidVimeoLink = () => {
            let vimeoRegexp = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/;

            return vimeoRegexp.test(this.model.video.url);
        }
    }
};

/**
 * Video control
 * @namespace cms.input.video
 */
export default angular.module('cms.input.video', []).component('cmsInputVideo', cmsInputVideo).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Controls/VideoControl/CmsInputVideo.js